import api from "../../../utilities/interseptor";
import Swal from 'sweetalert2';
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export const getDetallesServicios = (bitacoras,setDataModal)=>{
    api.get(`${apiUrl}/monitor/bitacora/getDetalleServicios?id_bitacoras=${bitacoras}`)
    .then((res)=>{
        setDataModal(res.data)  
    })
    .catch((error)=>{
        console.log("error",error);
    })
}
export const getPrecios = (bitacora,setPrecio)=>{
    api.get(`${apiUrl}/monitor/bitacora/getDetalleServicios/precio?id_bitacora=${bitacora}`)
    .then((res)=>{
        setPrecio(res.data)  
    })
    .catch((error)=>{
        console.log("error",error);
    })
}
export const updatePagos = (data,setDataModal,setOpenModal,setModalInfo)=>{
    
    api.patch(`${apiUrl}/monitor/bitacora/getDetalleServicios/precio/edit`,data)
    .then((res)=>{
        Swal.fire({
            icon: 'success',   // Icono de error
            title: 'Exelente', // Título de la alerta
            text: "se ha transferido correctamente", // Mensaje de error
            confirmButtonText: 'OK'  // Texto del botón de confirmación
          });
        //   cerramos los 3 modales
          setDataModal(null)
          setOpenModal(null)
          setModalInfo(null)
    })
    .catch((error)=>{
        console.log("error",error);
    })
}




